/** @jsx $jsx */
import { $jsx } from 'framework7';

function framework7Component(props, _ref) {
  var $f7 = _ref.$f7,
      $ = _ref.$,
      $on = _ref.$on,
      $update = _ref.$update;
  var scandata = "";
  console.log("OrderID:" + $("#orderid").val());

  var search = function search() {
    var codeEnter = $("#orderid").val();
    window.print_pay = "";

    if (codeEnter.includes("QR")) {
      window.origin = "rebuy";
      var arr = codeEnter.split(":");
      var data = "\n        {\n          \"orderEntry\":\"" + arr[4] + "\",\n          \"smsnum\":\"" + arr[2] + "-" + arr[3] + "\",\n          \"form\":\"" + arr[1] + "\"\n        }\n        ";
      scandata = "";
      $("#orderid").val("");
      console.log(data);
      window.data = JSON.parse(data);
      if (window.data.form == "1") $f7.views.main.router.navigate("/kiosk_4d_GD_only/");
      if (window.data.form == "2") $f7.views.main.router.navigate("/kiosk_4d_GD/");
      if (window.data.form == "3") $f7.views.main.router.navigate("/kiosk_6d_GD/");
      if (window.data.form == "4") $f7.views.main.router.navigate("/kiosk_4d_SG_only/");
      if (window.data.form == "5") $f7.views.main.router.navigate("/kiosk_4d_SG/");
      if (window.data.form == "6") $f7.views.main.router.navigate("/kiosk_4d_ST/");
      if (window.data.form == "7") $f7.views.main.router.navigate("/kiosk_6d_ST/");
      if (window.data.form == "8") $f7.views.main.router.navigate("/kiosk_pick_GD/");
      if (window.data.form == "9") $f7.views.main.router.navigate("/kiosk_pick_SG/");
      if (window.data.form == "9") $f7.views.main.router.navigate("/kiosk_pick_SG/");
      if (window.data.form == "11") $f7.views.main.router.navigate("/kiosk_pick_SG_S/");
      $f7.tab.show("#view-home", true);
      return;
    }

    $f7.request({
      method: 'get',
      url: 'https://api.timor4d.com/json/search.aspx',
      data: {
        orderId: $("#orderid").val(),
        reqId: window.uuid
      },
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', "Basic " + window.authbasic);
      },
      success: function success(data) {
        data = data.replace(",\"{", ",{");
        console.log(data);
        var data = JSON.parse(data);
        console.log(data);

        if (data.ALERT != undefined && data.ALERT != "") {
          $f7.dialog.alert(data.ALERT);
        }

        if (data.status == "1") {
          console.log("TEST:HIT");

          if (data.form == "88" || data.form == "188") {
            console.log("TEST:HIT2");
            window.print_text = "{CENTER}";
            window.print_text += "{BR}{BR}";
            window.print_text += "{BR}Agent     :" + data.receipt[4].value;
            window.print_text += "{BR}Date Time :" + data.dateTime;
            window.print_text += "{BR}Free Paper 58mm :" + data.receipt[0].qty;
            window.print_text += "{BR}Free Paper 80mm :" + data.receipt[1].qty;
            window.print_text += "{BR}Buy Paper 58mm  :" + data.receipt[2].qty;
            window.print_text += "{BR}Buy Paper 80mm  :" + data.receipt[3].qty;
            window.print_text += "{BR}{BR} TOTAL : $" + data.total;
            window.print_text += "{BR}{BR}PAID{BR}";
            if (data.orderStatus == "1") window.print_text += "{BR}PRINT COPY{BR}";
            window.print_qr = data.orderID;
            window.print_barcode = data.orderID;
            window.print_orderId = data.orderID;
            window.print_orderStatus = data.orderStatus;

            if (data.form == "188") {
              window.print_detail = "\n                  <div class=\"block\">\n                  <H1>Buy Ticket (eWallet)</H1>\n                  </div>\n                  ";
            }

            window.print_detail += "\n                 \n                  <div class=\"card data-table\">\n                  <table>\n                    <thead>\n                      <tr>\n                        <th class=\"label-cell\">Type</th>\n                        <th class=\"numeric-cell\">Quantity</th>\n                      </tr>\n                    </thead>\n                    <tbody>\n                      <tr>\n                        <td class=\"label-cell\">Agent</td>\n                        <td class=\"numeric-cell\">" + data.receipt[4].value + "</td>\n                      </tr>\n                      <tr>\n                        <td class=\"label-cell\">Free Paper 58 mm</td>\n                        <td class=\"numeric-cell\">" + data.receipt[0].qty + "</td>\n                      </tr>\n                      <tr>\n                        <td class=\"label-cell\">Free Paper 80 mm</td>\n                        <td class=\"numeric-cell\">" + data.receipt[1].qty + "</td>\n                      </tr>\n                      <tr>\n                        <td class=\"label-cell\">Buy Paper 58 mm</td>\n                        <td class=\"numeric-cell\">" + data.receipt[2].qty + "</td>\n                      </tr>\n                      <tr>\n                        <td class=\"label-cell\">Buy Paper 80 mm</td>\n                        <td class=\"numeric-cell\">" + data.receipt[3].qty + "</td>\n                      </tr>\n                    </tbody>\n                  </table>\n                  <div class=\"data-table-footer\">\n                    <H1 style=\"margin-right:16px\">TOTAL: $" + data.total + "</H1> \n                  </div>\n                  </div>\n                ";
            if (data.orderStatus == "0") window.print_pay = "true";
            window.print_pay_url = "payPaper.aspx";
            window.print_page = "/cashier_pay/";
            $f7.views.current.router.navigate("/GEN_receipt/", {
              force: true
            });
          } else if (data.form == "99" || data.form == "199") {
            console.log("TEST:HIT2");
            window.print_text = "{CENTER}";
            window.print_text += "{BR}{BR}";
            window.print_text += "{BR}{BR}TOPUP TOTAL : $" + data.orderEntry;
            window.print_text += "{BR}{BR}PAID{BR}";
            if (data.orderStatus == "1") window.print_text += "{BR}PRINT COPY{BR}";
            window.print_qr = data.orderID;
            window.print_barcode = data.orderID;
            window.print_orderId = data.orderID;
            window.print_orderStatus = data.orderStatus;

            if (data.form == "199") {
              window.print_hide_button = "true";
            }

            window.print_detail = "\n                  <div class=\"card data-table\">\n                  <table>\n                    <thead>\n                      <tr>\n                        <th class=\"label-cell\">Order Type</th>\n                        <th class=\"numeric-cell\">Amount</th>\n                      </tr>\n                    </thead>\n                    <tbody>\n                      <tr>\n                        <td class=\"label-cell\">Topup</td>\n                        <td class=\"numeric-cell\">" + data.orderEntry + "</td>\n                      </tr>\n                    </tbody>\n                  </table>\n                  <div class=\"data-table-footer\">\n                    <H1 style=\"margin-right:16px\">TOTAL: $" + data.total + "</H1> \n                  </div>\n                  </div>\n                ";
            if (data.orderStatus == "0") window.print_pay = "true";
            window.print_page = "/cashier_pay/";
            window.print_pay_url = "payTopup.aspx";
            $f7.views.current.router.navigate("/GEN_receipt/", {
              force: true
            });
          } else if (data.form == "77" || data.form == "177") {
            console.log("TEST:HIT SETTLEMENT");
            window.print_text = "{LEFT}";
            window.print_text += "{BR}";
            window.print_text += "{BR}Agent       : " + data.receipt[0].value;
            window.print_text += "{BR}Master      : " + data.receipt[1].value;
            window.print_text += "{BR}Sales       : $" + data.receipt[2].value;
            window.print_text += "{BR}Sales Comm. : $" + data.receipt[3].value; //window.print_text += "{BR}Win Comm.   : $" + data.receipt[4].value;

            window.print_text += "{BR}Rent Device : " + data.receipt[5].value;
            window.print_text += "{BR}Rent Data   : " + data.receipt[6].value;
            window.print_text += "{BR}";
            window.print_text += "{CENTER}";
            window.print_text += "{BR}{BR}";
            window.print_text += "{BR}{BR}SETTLEMENT TOTAL : $" + data.total;
            window.print_text += "{BR}{BR}{H}{B}PAID{/B}{/H}{BR}";
            window.print_text += "{BR}{BR}";
            window.print_text += "{LEFT}{BR}Name:";
            window.print_text += "{BR}IC:";
            window.print_text += "{BR}Date:{BR}{BR}";
            if (data.orderStatus == "1") window.print_text += "{BR}PRINT COPY{BR}";
            window.print_qr = data.orderID;
            window.print_barcode = data.orderID;
            window.print_total_after_barcode = "{BR}{BR}SETTLEMENT TOTAL : $" + data.total;
            window.print_orderId = data.orderID;
            window.print_orderStatus = data.orderStatus;

            if (data.form == "177") {
              window.print_hide_button = "true";
            }

            window.print_detail = "\n                <div class=\"card data-table\">\n                <table>\n                  <thead>\n                    <tr>\n                      <th class=\"label-cell\">Type</th>\n                      <th class=\"numeric-cell\">Description</th>\n                    </tr>\n                  </thead>\n                  <tbody>\n                    <tr>\n                      <td class=\"label-cell\">Agent</td>\n                      <td class=\"numeric-cell\">" + data.receipt[0].value + "</td>\n                    </tr>\n                    <tr>\n                      <td class=\"label-cell\">Master</td>\n                      <td class=\"numeric-cell\">" + data.receipt[1].value + "</td>\n                    </tr>\n                    <tr>\n                      <td class=\"label-cell\">Sales</td>\n                      <td class=\"numeric-cell\">$" + data.receipt[2].value + "</td>\n                    </tr>\n                    <tr>\n                      <td class=\"label-cell\">Sales Commission</td>\n                      <td class=\"numeric-cell\">$" + data.receipt[3].value + "</td>\n                    </tr>\n                    <tr style=\"display:none\">\n                      <td class=\"label-cell\">Winning Commission</td>\n                      <td class=\"numeric-cell\">$" + data.receipt[4].value + "</td>\n                    </tr>\n                    <tr>\n                      <td class=\"label-cell\">Device Rental</td>\n                      <td class=\"numeric-cell\">" + data.receipt[5].value + "</td>\n                    </tr>\n                    <tr>\n                      <td class=\"label-cell\">Data Rental</td>\n                      <td class=\"numeric-cell\">" + data.receipt[6].value + "</td>\n                    </tr>\n                    <tr>\n                      <td class=\"label-cell\">Outstanding</td>\n                      <td class=\"numeric-cell\">" + data.receipt[7].value + "</td>\n                    </tr>\n                  </tbody>\n                </table>\n                <div class=\"data-table-footer\">\n                  <H1 style=\"margin-right:16px\">TOTAL: $" + data.total + "</H1> \n                </div>\n                </div>\n              ";
            if (data.orderStatus == "0") window.print_pay = "true";
            window.print_pay_url = "payOutstanding.aspx";
            window.print_page = "/cashier_pay/";
            $f7.views.current.router.navigate("/GEN_receipt/", {
              force: true
            });
          } else if (data.form == "111") {
            console.log("TEST: WITHDRAW");
            window.print_text = "{CENTER}";
            window.print_text += "{BR}{BR}";
            window.print_text += "{LEFT}{BR}Agent:" + data.receipt[0].value;
            window.print_text += "{LEFT}{BR}DateTime:" + data.dateTime;
            window.print_text += "{BR}{BR}WITHDRAW TOTAL : $" + data.total;
            window.print_text += "{BR}{BR}{H}{B}PAID{/B}{/H}{BR}";
            window.print_text += "{BR}{BR}";
            window.print_text += "{LEFT}{BR}Name:";
            window.print_text += "{BR}IC:";
            window.print_text += "{BR}Date:{BR}{BR}";
            if (data.orderStatus == "1") window.print_text += "{BR}PRINT COPY{BR}";
            window.print_qr = data.orderID;
            window.print_barcode = data.orderID;
            window.print_total_after_barcode = "{BR}{BR}WITHDRAW TOTAL : $" + data.total;
            window.print_orderId = data.orderID;
            window.print_orderStatus = data.orderStatus;
            window.print_detail = "\n                  <div class=\"card data-table\">\n                  <table>\n                    <thead>\n                      <tr>\n                        <th class=\"label-cell\">Type</th>\n                        <th class=\"numeric-cell\">Description</th>\n                      </tr>\n                    </thead>\n                    <tbody>\n                      <tr>\n                        <td class=\"label-cell\">Agent</td>\n                        <td class=\"numeric-cell\">" + data.receipt[0].value + "</td>\n                      </tr>\n                      <tr>\n                        <td class=\"label-cell\">Master</td>\n                        <td class=\"numeric-cell\">" + data.receipt[1].value + "</td>\n                      </tr>\n                      <tr>\n                        <td class=\"label-cell\">e-Wallet withdraw</td>\n                        <td class=\"numeric-cell\">" + data.total + "</td>\n                      </tr>\n                    </tbody>\n                  </table>\n                  <div class=\"data-table-footer\">\n                    <H1 style=\"margin-right:16px\">TOTAL: $" + data.total + "</H1> \n                  </div>\n                  </div>\n                ";
            if (data.orderStatus == "0") window.print_pay = "true";
            window.print_pay_url = "payWithdraw.aspx";
            window.print_page = "/cashier_pay/";
            $f7.views.current.router.navigate("/GEN_receipt/", {
              force: true
            });
          } else {
            window.orderId = $("#orderid").val();
            $("#orderid").val("");
            window.origin = "pay";
            $f7.views.current.router.navigate("/cashier_receipt/", {
              force: true
            });
          }
        } else {
          if (data.errmsg != "" && data.errmsg != undefined) $f7.dialog.alert(data.errmsg);
          if (data.errMsg != "" && data.errMsg != undefined) $f7.dialog.alert(data.errMsg);
        }
      }
    });
  };

  $on('pageAfterOut', function () {
    clearInterval(window.langPlace2);
  });
  $on('pageInit', function () {
    window.langPlace2 = setInterval(function () {
      if (window.lang == "tl") document.getElementById("orderid").placeholder = "Tama hameno id";
      if (window.lang == "en") document.getElementById("orderid").placeholder = "Enter your order id";
    }, 1000);
    scandata = ""; //$('#orderid').blur();

    $('#orderid').focus();
    setInterval(function () {
      if ($f7.views.current.name == "pay") {
        $('#orderid').focus();
      }
    }, 100);
    $("#orderid").on('keypress', function (e) {
      if (e.which == 13) {
        search();
      }
    });
    $('body').on('keyup', function (event) {
      if ($f7.views.current.name == "pay") {
        console.log("this is the current name" + $f7.views.current.name);
        var key = event.key;
        console.log(key);
        key = key.toUpperCase();
        if (key != "SHIFT" && key != "ENTER") scandata += key;

        if (key == "ENTER") {
          $("#orderid").val(scandata); //window.orderId = scandata;
          //window.origin = "pay";
          //$("#orderid").val(scandata);

          scandata = "";
          search(); //$f7.views.current.router.navigate("/cashier_receipt/",{force:true});
        }
      }
    });
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="about">
  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner sliding">
      <!-- <div class="left">
        <a href="#" class="link back">
          <i class="icon icon-back"></i>
          <span class="if-not-md">Back</span>
        </a>
      </div> -->
      <div class="title">Scan 
        <span class='en'> Receipt</span>
        <span class='cn'></span>
        <span class='tl'> Resibu</span>
      </div>
    </div>
  </div>
  <div class="page-content">
    
    <div class="block" style="text-align: center;">
      <!-- <p>Please scan the customer receipt barcode to view order, once cash collected from customer <br/>please press paid to print receipt invoice.</p> -->
      <img src='static/images/scan.png' width='300px'/>
      <p>
        
          <span class='en'>OR</span>
          <span class='cn'>或者</span>
          <span class='tl'>KA</span>
        
      </p>
      <div class="list no-hairlines-md">
        <ul  style="background-color: transparent">
          <li class="item-content item-input item-input-outline" >
            <div class="item-inner">
              <div class="item-title item-floating-label">
                <span class='en'>ORDER ID</span>
                <span class='cn'>订单编号</span>
                <span class='tl'>HAMENO ID</span>
              </div>
              <div class="item-input-wrap">
                <input type="text" id="orderid" placeholder="Key in receipt Order ID" />
                <span class="input-clear-button"></span>
              </div>
              <button class="button button-fill" @click=${search}>
                <span class='en'>SEARCH</span>
                <span class='cn'>搜索</span>
                <span class='tl'>BUKA</span>
              </button>
            </div>
          </li>
        </ul>
      </div>
      <div class="orderid">
      
      </div>
    </div>
  </div>
</div>
`
    }
    ;
}

framework7Component.id = 'c3bdf10685';
export default framework7Component;